// extracted by mini-css-extract-plugin
export default {"contentWrapper":"Gfda240","iconNoSlotAvailable":"G180262"};